// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__CXH02","label":"styles_label__qNrow","icon":"styles_icon__Z4L24"};